import React from 'react';

import css from './Container.module.css';

export const Container = ({ children, className }) => (
  <div className={`${css.container}${className ? ` ${className}` : ''}`}>{children}</div>
);
